// extracted by mini-css-extract-plugin
module.exports = {"content":"implements_content__1TC8a","center":"implements_center__3vqU_"};